import { getBackendUri } from '../utils/EnvConfigUtils';
import { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import FetchUtils from './fetch_utils';

const fetchUtils = new FetchUtils();

const updateWebPushNotification = (action) => (roleType) => (data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/notification_registry/desktop_push_notification_registries/${action}`;

	return new Promise((resolve, reject) => {
		fetchUtils
			.post(
				baseUrl + apiUrl,
				Object.assign({
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data,
				})
			)
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				const d = json;
				// if (status === 401) {
				//   dispatch(logoutSuccess());
				// }
				if (d.status === 'error') {
					reject(d.message);
				} else {
					resolve(d.data);
				}
			})
			.catch((d) => {
				reject(d.message);
			});
	});
};

export const updateWebPushNotificationForLogIn = (roleType) => (data) =>
	updateWebPushNotification('logged_in')(roleType)(data);
export const updateWebPushNotificationForLogOut = (roleType) => (data) =>
	updateWebPushNotification('logged_out')(roleType)(data);
